import script from "./AutorizationBody.vue?vue&type=script&setup=true&lang=js"
export * from "./AutorizationBody.vue?vue&type=script&setup=true&lang=js"

import "./AutorizationBody.vue?vue&type=style&index=0&id=0805c15e&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0805c15e"]])

export default __exports__